import React, { useState } from "react";
import { useCart } from "./CartContext";
import Button from "react-bootstrap/Button";
import AddToCartAlert from "./AddToCartAlert";
import "../../styles.css";

const AddToCart = ({ product }) => {
  const { addToCart } = useCart();
  const [fabric, setFabric] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [rangeModel, setRangeModel] = useState("");
  const [optionalExtras, setOptionalExtras] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false); // Track visibility of the alert

  const handleCloseAlert = () => setShowAlert(false);

  // Calculate total price based on quantity
  const totalPrice = (product.price * quantity).toFixed(2); // Ensure it's rounded to 2 decimal places

  const handleAddToCart = () => {
    if (!fabric.trim()) {
      setAlertMessage("Please specify a fabric.");
      setShowAlert(true);
      return;
    }

    if (!rangeModel.trim()) {
      setAlertMessage("Please select a range model.");
      setShowAlert(true);
      return;
    }

    const item = {
      id: product.id,
      name: product.name,
      fabric,
      rangeModel,
      optionalExtras: optionalExtras.trim() || null, // Optional field
      quantity,
      rangeImg: product.rangeImg,
      price: product.price, // Add the price field here
    };

    addToCart(item);
    setAlertMessage("Item successfully added to cart!");
    setShowAlert(true);
  };

  return (
    <div className="add-to-cart-container">
      <h3 className="addtocart-title">{product.name}</h3>

      {/* Custom alert component */}
      <AddToCartAlert
        show={showAlert}
        handleClose={handleCloseAlert}
        message={alertMessage}
      />

      <label className="addtocart-label">
        <span>Range Model:</span>
        <select
          value={rangeModel}
          onChange={(e) => setRangeModel(e.target.value)}
          className="addtocart-field"
        >
          <option value="" disabled>
            Select a range model
          </option>
          {product.rangeModel.map((model, index) => (
            <option key={index} value={model}>
              {model}
            </option>
          ))}
        </select>
      </label>

      <label className="addtocart-label">
        <span>Fabric:</span>
        <input
          type="text"
          placeholder="Enter fabric choice"
          value={fabric}
          onChange={(e) => setFabric(e.target.value)}
          className="addtocart-field"
        />
      </label>

      <label className="addtocart-label">
        <span>Optional Extras:</span>
        <input
          type="text"
          placeholder="Any extras?"
          value={optionalExtras}
          onChange={(e) => setOptionalExtras(e.target.value)}
          className="addtocart-field"
        />
      </label>

      <label className="addtocart-label">
        <span>Quantity:</span>
        <input
          type="number"
          min="1"
          value={quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value))}
          className="addtocart-field"
        />
      </label>

      <div className="addtocart-price-container">
        <b className="addtocart-price">{`£${totalPrice}*`}</b>
        <i className="addtocart-smallprint">
          *Guide price only. For up-to-date pricing, including extras - see our price list.
        </i>
      </div>

      <Button className="addtocart-button" onClick={handleAddToCart}>
        Add to Cart
      </Button>
    </div>
  );
};

export default AddToCart;
